import axios from '../index';

export const requestReportPdfParse = ({ formData }) =>
  axios.post('/upload/pdf-report', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
